<script>
  import Select from 'svelte-select';
  import FormInput from '../FormControls/FormInput.svelte';
  import FormTextarea from '../FormControls/FormTextarea.svelte';
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import { customInputEvent, searchKeyByValue } from 'components/Helper.js';

  export let form;
  export let errors;
  export let handleChange;
  export let fundProfiles;
  export let selectedFundStrategy;
  export let selectUnitsInfo;
  export let states = [];
  import DropDown from '../../components/DropDown.svelte';
  import { getContext } from 'svelte';
  const showDialog = getContext('showDialog');

  const defaultValue = {
    id: '',
    name: '',
    unitFundStrategyId: '',
    ccc: '',
    pmac: '',
    cik: '',
    passphrase: '',
    password: '',
    renewal: '',
    renewalDate: null,
    notes: '',
    blueskys: [],
  };

  function addFunds() {
    let arr = $form.fundProfiles;
    defaultValue.blueskys = [];
    arr.push({ ...defaultValue });
    $form.fundProfiles = arr;
  }

  // $: if($form.fundProfiles.length == 0){
  //      addFunds()
  //  }

  const removeFund = (key) => {
    let arr = $form.fundProfiles;
    arr.splice(key, 1);
    $form.fundProfiles = arr;

    let errorArr = $errors.fundProfiles;
    errorArr.splice(key, 1);
    $errors.fundProfiles = errorArr;
  };

  //Fund Profile
  let fundProfileError = [];
  const checkError = () => {
    for (var i in $errors.fundProfiles) {
      fundProfileError[i] =
        $errors.fundProfiles[i].name ||
        $errors.fundProfiles[i].unitFundStrategyId ||
        $errors.fundProfiles[i].ccc ||
        $errors.fundProfiles[i].pmac ||
        $errors.fundProfiles[i].cik ||
        $errors.fundProfiles[i].passphrase ||
        $errors.fundProfiles[i].password ||
        $errors.fundProfiles[i].renewal ||
        ($form.fundProfiles[i].renewal == 1 && $errors.fundProfiles[i].renewalDate);

      for (var j in $errors.fundProfiles[i].blueskys) {
        if ($errors.fundProfiles[i].blueskys[j] && $errors.fundProfiles[i].blueskys[j].date != '') {
          fundProfileError[i] = true;
        }
      }
    }
  };

  $: $errors && checkError();
  const addBlueSky = (i) => {
    let selectStates = states.filter((item) => item.checked);
    if (selectStates.length > 0) {
      let arr = $form.fundProfiles[i].blueskys;
      for (let i in selectStates) {
        let selectState = selectStates[i];
        if (searchKeyByValue(arr, 'stateId', selectState.id) !== -1) {
          return showDialog({ message: 'Blue Sky already selected' });
        }
      }
      for (let i in selectStates) {
        let selectedStateLabel = selectStates[i];
        arr.push({
          stateId: selectedStateLabel.id,
          name: selectedStateLabel.name,
          date: '',
        });
      }
      $form.fundProfiles[i].blueskys = arr;
      setTimeout(() => {
        states = states.map((item) => {
          item.checked = false;
          return item;
        });
      }, 100);
    } else {
      showDialog({ message: 'Please select user' });
    }
  };
</script>

<div class="d-flex flex-column h-100 p-3">
  <div class="profile-content mx-auto w-100">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Fund Profile</span></h3>
    </div>
  </div>
  <div class="page-content">
    <div class="profile-content mx-auto h-100 d-flex flex-column">
      <ul
        class="nav nav nav-pills mb-2"
        id="FundTab"
        role="tablist"
      >
        {#each $form.fundProfiles as item, i}
          <li
            class="nav-item"
            role="presentation"
          >
            <a
              class="nav-link mb-1 {i == $form.fundProfiles.length - 1
                ? 'active'
                : ''}    {fundProfileError[i] != undefined && fundProfileError[i] != ''
                ? 'error'
                : ''}"
              id="funds{i}-tab"
              data-bs-toggle="tab"
              href="#funds{i}"
              role="tab"
              aria-controls="funds"
              aria-selected="true"
              >{$form.fundProfiles[i].name.trim() != ''
                ? $form.fundProfiles[i].name.trim().substr(0, 20) +
                  ($form.fundProfiles[i].name.trim().length > 20 ? '...' : '')
                : 'Fund ' + (i + 1)}
            </a>
          </li>
        {/each}
        <li
          class="nav-item"
          role="presentation"
        >
          <button
            on:click={addFunds}
            class="nav-link bg-transparent border-0 color-blue font-weight-500"
          >
            <img
              class="icon-10"
              alt=""
              src="/images/plus.svg"
            /> Add New
          </button>
        </li>
      </ul>
      <div
        class="tab-content page-content content-block"
        id="myTabContent"
      >
        {#each $form.fundProfiles as item, i}
          <div
            class="tab-pane fade {i == $form.fundProfiles.length - 1 ? 'show  active' : ''}"
            id="funds{i}"
            role="tabpanel"
            aria-labelledby="funds-tab"
          >
            <div class="mt-3 mb-3">
              <!-- {#if i != 0 } -->
              <div class="d-flex justify-content-end mb-3">
                <button
                  on:click={() => removeFund(i)}
                  class="bg-transparent border-0 color-red d-flex flex-row"
                >
                  <img
                    alt=""
                    class="icon-16 me-1"
                    src="/images/trash.svg"
                  /> <span>Remove</span>
                </button>
              </div>
              <!-- {/if} -->
              <div class="row">
                <div class="col">
                  <FormInput
                    name={`fundProfiles[${i}].name`}
                    label="Fund Name"
                    type="text"
                    placeholder="Enter Fund Name"
                    handleChange={handleChange}
                    bind:value={$form.fundProfiles[i].name}
                    error={$errors.fundProfiles[i] != undefined
                      ? $errors.fundProfiles[i].name
                      : undefined}
                  />
                </div>
                <div class="col">
                  <div class="form-group mb-3 select-block select-client-type">
                    <label
                      for=""
                      class="form-label">Strategy</label
                    >
                    <Select
                      bind:selectedValue={selectedFundStrategy[i]}
                      showChevron={true}
                      isClearable={true}
                      items={fundProfiles}
                      getSelectionLabel={(option) => {
                        return option.name;
                      }}
                      on:select={(ev) => {
                        $form.fundProfiles[i].unitFundStrategyId = ev.detail.id;
                      }}
                      on:clear={(ev) => {
                        $form.fundProfiles[i].unitFundStrategyId = '';
                      }}
                      optionIdentifier="id"
                      getOptionLabel={(option) => {
                        return option.name;
                      }}
                      placeholder="Select Strategy"
                    />
                  </div>
                </div>
              </div>
              <div class="fields-block px-3 pt-4 pb-3 position-relative mt-2">
                <label
                  for=""
                  class="title-fields position-absolute px-3 font-weight-500"
                  >SEC Edgar Filing Info</label
                >
                {#if selectUnitsInfo.usCompliance}
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <FormInput
                          name={`fundProfiles[${i}].ccc`}
                          label="CCC"
                          type="text"
                          placeholder="Enter CCC"
                          handleChange={handleChange}
                          bind:value={$form.fundProfiles[i].ccc}
                          error={$errors.fundProfiles[i] != undefined
                            ? $errors.fundProfiles[i].ccc
                            : undefined}
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <FormInput
                          name={`fundProfiles[${i}].pmac`}
                          label="PMAC"
                          type="text"
                          placeholder="Enter PMAC"
                          handleChange={handleChange}
                          bind:value={$form.fundProfiles[i].pmac}
                          error={$errors.fundProfiles[i] != undefined
                            ? $errors.fundProfiles[i].pmac
                            : undefined}
                        />
                      </div>
                    </div>
                  </div>
                {/if}

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <FormInput
                        name={`fundProfiles[${i}].cik`}
                        label="CIK"
                        type="text"
                        placeholder="Enter CIK"
                        handleChange={handleChange}
                        bind:value={$form.fundProfiles[i].cik}
                        error={$errors.fundProfiles[i] != undefined
                          ? $errors.fundProfiles[i].cik
                          : undefined}
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <FormInput
                        name={`fundProfiles[${i}].passphrase`}
                        label="Passphrase"
                        type="text"
                        placeholder="Enter Passphrase"
                        handleChange={handleChange}
                        bind:value={$form.fundProfiles[i].passphrase}
                        error={$errors.fundProfiles[i] != undefined
                          ? $errors.fundProfiles[i].passphrase
                          : undefined}
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <FormInput
                        name={`fundProfiles[${i}].password`}
                        label="Password"
                        type="text"
                        placeholder="Enter Password"
                        handleChange={handleChange}
                        bind:value={$form.fundProfiles[i].password}
                        error={$errors.fundProfiles[i] != undefined
                          ? $errors.fundProfiles[i].password
                          : undefined}
                      />
                    </div>
                  </div>
                </div>

                {#if selectUnitsInfo.usCompliance}
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label
                          for=""
                          class="form-label">Renewal</label
                        >
                        <div class="d-flex flex-row align-items-center radio-block-btn">
                          <div class="form-label mb-0 me-3">
                            <div class="radio c-radio">
                              <label>
                                <input
                                  type="radio"
                                  name={'fundProfiles[' + i + ']'}
                                  checked={$form.fundProfiles[i].renewal == 1}
                                  on:change={(event) => ($form.fundProfiles[i].renewal = 1)}
                                />
                                <span class="" />
                                Yes
                              </label>
                            </div>
                          </div>
                          <div class="form-label mb-0">
                            <div class="radio c-radio">
                              <label>
                                <input
                                  type="radio"
                                  name={'fundProfiles[' + i + ']'}
                                  checked={$form.fundProfiles[i].renewal == 0}
                                  on:change={(event) => {
                                    $form.fundProfiles[i].renewal = 0;
                                    $form.fundProfiles[i].renewalDate = null;
                                  }}
                                />
                                <span class="" />
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {#if $form.fundProfiles[i].renewal === 1}
                      <div class="col-md-6">
                        <div class="form-group mb-3">
                          <label
                            for=""
                            class="form-label">Form D Annual Filing Date</label
                          >
                          <DatePicker
                            Style=" calendar-input-block anual-filing-date-picker"
                            placeholder="End Date"
                            on:change={(value) => {
                              $form.fundProfiles[i].renewalDate = value.detail[1];
                              handleChange(
                                customInputEvent(`fundProfiles[${i}].renewalDate`, value.detail[1]),
                              );
                            }}
                            value={$form.fundProfiles[i].renewalDate}
                            error={$errors.fundProfiles[i] != undefined
                              ? $errors.fundProfiles[i].renewalDate
                              : undefined}
                            name={`fundProfiles[${i}].renewalDate`}
                          />
                        </div>
                      </div>
                    {/if}
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label
                        for=""
                        class="form-label mb-2 mt-3">BlueSky Filings</label
                      >
                    </div>
                    <div class="row">
                      <div class="col-md-6 engagement-dropdown mb-2 bluesky-dropdown">
                        <DropDown
                          checkbox={true}
                          active={true}
                          searchbox={true}
                          title="Select: State(s)"
                          labelFields="name"
                          keyFields="id"
                          option={states}
                          checkedFields="checked"
                          Style="select-block font-size-13 w-100"
                          on:onSelect={(event) => {
                            addBlueSky(i);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {#each $form.fundProfiles[i].blueskys as blueskyItem, key}
                    <div class="fund-billing-items">
                      <div class="row align-items-center mb-2">
                        <div class="col-md-5">
                          <div class="form-label mb-0">
                            {$form.fundProfiles[i].blueskys[key].name}
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="fund-date-picker">
                            <DatePicker
                              style="active  select-border me-1 calendar-input-block"
                              placeholder="Select Date"
                              on:change={(value) => {
                                $form.fundProfiles[i].blueskys[key].date = value.detail[1];
                                handleChange(
                                  customInputEvent(
                                    `fundProfiles[${i}].blueskys[${key}].date`,
                                    value.detail[1],
                                  ),
                                );
                              }}
                              value={$form.fundProfiles[i].blueskys[key].date}
                              error={$errors.fundProfiles[i] != undefined &&
                              $errors.fundProfiles[i].blueskys != undefined &&
                              $errors.fundProfiles[i].blueskys[key] != undefined
                                ? $errors.fundProfiles[i].blueskys[key].date
                                : undefined}
                              name={`fundProfiles[${i}].blueskys[${key}].date`}
                            />
                          </div>
                        </div>
                        <div class="col-md-1 text-right">
                          <button
                            on:click={() => {
                              showDialog({
                                isDeleteModel: true,
                                type: 'confirm',
                                title: '',
                                message: 'Are you sure ?',
                                okFunc: () => {
                                  let oldUsers = $form.fundProfiles[i].blueskys;
                                  oldUsers.splice(key, 1);
                                  $form.fundProfiles[i].blueskys = oldUsers;
                                },
                              });
                            }}
                            class="btn btn-link bg-transparent border-0 shadow-none p-0 ms-1"
                          >
                            <img
                              class="icon-16"
                              alt=""
                              src="/images/remove.svg"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  {/each}
                {/if}
                {#if !selectUnitsInfo.outsourcedCfo}
                  <div class="row align-items-center mb-2">
                    <div class="col-md-12">
                      <div class="form-group mb-3">
                        <FormTextarea
                          label="Fund Notes"
                          name="notes"
                          placeholder="Enter Fund Notes"
                          bind:value={$form.fundProfiles[i].notes}
                        />
                      </div>
                    </div>
                  </div>
                {/if}
              </div>
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .nav-item {
    .nav-link {
      color: #206bc4;
      /* background: $lead-color; */
      margin-right: 4px;
      &.active {
        background: $blue-color;
        color: #fff;
      }
    }
  }
  .content-block {
    overflow-x: hidden;
  }
  .fund-billing-items {
    min-height: 50px;
    .fund-date-picker {
      min-height: 35px;
      :global(.flatpickr) {
        max-width: 145px;
      }
    }
    :global(.anual-filing-date-picker) {
      max-width: 145px;
    }
  }
</style>
